import { createContext, useContext } from 'react';

const InstallmentsContext = createContext<{ installment: any } | undefined>(undefined);

export const InstallmentsContextProvider = InstallmentsContext.Provider;

export function useInstallments() {
	return useContext(InstallmentsContext);
}
